declare const env: {
    readonly AI_URL: string;
    readonly AUTH_URL: string;
    readonly FILES_API_URL: string;
    readonly UPLOAD_URL: string;
    readonly API_URL: string;
    readonly WS_URL: string;
};

export const {
    AI_URL,
    AUTH_URL,
    FILES_API_URL,
    UPLOAD_URL,
    API_URL,
    WS_URL
} = env;